<script setup lang="ts">
/**
 * What QuickTide is, whose it is and on what terms: the old app's "Over QuickTide", in the
 * same order -- the name and version, that it is independent and where its numbers come from,
 * who it is for, that it is used at one's own risk, and the way to the manual and to Nautin.
 * The manual is a page of its own and stays one.
 */
import { computed } from 'vue'
import { useAppStore } from '../store'
import ScreenTitle from '../components/ScreenTitle.vue'

const store = useAppStore()
const released = computed(() => (store.appDate ? new Date(store.appDate).toLocaleDateString(store.settings.locale, { dateStyle: 'long' }) : ''))
</script>

<template>
  <main class="screen aboutscreen">
    <div class="header">
      <ScreenTitle>{{ store.t('menuAbout') }}</ScreenTitle>
    </div>

    <div class="aboutmast">
      <img src="/icon-192.png" alt="" width="72" height="72">
      <p class="aboutname">QuickTide<sup>®</sup></p>
      <p class="small muted">{{ store.t('version') }} {{ store.appVersion }}<template v-if="released"> · {{ released }}</template></p>
      <p class="aboutmaker">Nautin · <em>Basis voor een behouden vaart</em></p>
    </div>

    <p>{{ store.t('aboutIntro') }}</p>
    <p>{{ store.t('aboutIndependent') }}</p>

    <h2>{{ store.t('aboutSources') }}</h2>
    <div class="setting"><span>{{ store.t('aboutTideData') }}</span><span>Rijkswaterstaat, BSH, WSV</span></div>
    <div class="setting"><span>{{ store.t('weatherTitle') }}</span><span>KNMI, DWD</span></div>
    <div class="setting"><span>{{ store.t('aboutSoundings') }}</span><span>Rijkswaterstaat, WSV {{ store.t('aboutAndOthers') }}</span></div>

    <h2>{{ store.t('aboutForWhom') }}</h2>
    <p>{{ store.t('entryWho') }}</p>

    <p class="notice small">{{ store.t('aboutCare') }} {{ store.t('aboutDisclaimer') }}</p>

    <div class="setting">
      <span>{{ store.t('manual') }}</span>
      <a class="link" href="/help/" target="_blank" rel="noopener">{{ store.t('openManual') }}</a>
    </div>
    <div class="setting">
      <span>{{ store.t('aboutMore') }}</span>
      <a class="link" href="https://www.nautin.nl/quicktide" target="_blank" rel="noopener">www.nautin.nl/quicktide</a>
    </div>

    <p class="aboutfoot small muted">{{ store.t('aboutTrademark') }}<br>© Copyright Stichting Nautin</p>
  </main>
</template>
